var vue_candler = new Vue({
	el: '#candler',
	delimiters: ['[[',']]'],
	data: {
		ready: false,
		type: 'set',
		permissions: window.candle_permissions,
	},
	created: function(){
		var type = false;
		// set default based on availability
		switch ( true ) {
			case ( this.permissions.set ) :    type = 'set';    break;
			case ( this.permissions.refill ) : type = 'refill'; break;
		}
		// change default based on params and availability
		function get_params(url) { var href = url ? url : window.location.href; if ( href.indexOf('?') == -1 ) { return []; } var vars = [], hash; var hashes = href.slice(href.indexOf('?') + 1).split('&'); for(var i = 0; i < hashes.length; i++) { hash = hashes[i].split('='); vars[hash[0]] = hash[1]; } return vars; }
		function get_param(name) { var params = get_params(); return ( params[name] ) ? params[name] : false; }
		var paramtype = get_param('type');
		if ( paramtype && this.permissions[paramtype] ) {
			type = paramtype;
		}
		this.set_type(type,paramtype);
	},
	methods: {
		set_type: function(type,scroll){
			this.type = type;
			if ( scroll ) {
				scroll_gallery($('#gallery'),false,false,type);
			}
			$('[data-combination]').addClass('hidden');
			$('[data-combination="'+type+'"]').removeClass('hidden');
		},
	}
});



